import { HeaderLogoProps } from './types';
import { getColorway } from 'utils/styles';
import { toMediaAsset } from 'components/shared/Media/toMediaAsset';
import { getEntryNativeFields } from 'utils/entryNativeFields';
import HeaderLogoItem from './HeaderLogoItem';

const HeaderLogo = (props: HeaderLogoProps) => {
  const { sectionName, color, items } = getEntryNativeFields(props);

  return (
    <section {...(sectionName != null && { id: encodeURIComponent(sectionName) })} className={getColorway(color)}>
      <div className="flex justify-center mx-[56px]">
        <div className="flex my-2 justify-between items-center flex-nowrap">
          {items?.map((item, i) =>
            item && 'fields' in item ? (
              <HeaderLogoItem
                key={i}
                variant={item.fields.variant}
                image={item.fields.image && toMediaAsset(item.fields.image)}
                aspectRatio={item.fields.aspectRatio?.fields && { value: item.fields.aspectRatio.fields.value }}
                illustration={item.fields.illustration}
                icon={item.fields.icon}
              />
            ) : null,
          )}
        </div>
      </div>
    </section>
  );
};

export default HeaderLogo;
